(function () {
  let popupShown = false;

  const isLoggedIn = !!window.customerLoggedIn;

  /* ============================
     BUILD POPUP ROOT
     ============================ */
  const root = document.getElementById("dw-exit-popup-root");
  if (!root) return;

  root.innerHTML = `
    <div id="dw-exit-popup" style="display:none;">
      <div class="dw-overlay">
        <div class="dw-popup">
          <button class="dw-close">×</button>
          <div id="dw-content"></div>
        </div>
      </div>
    </div>
  `;

  const popup = document.getElementById("dw-exit-popup");
  const content = document.getElementById("dw-content");

  /* ============================
     TRACKING HELPERS
     ============================ */

  function markPopupView() {
    sessionStorage.setItem("dw_popup_viewed", "true");
  }

  function markPopupConversion(action) {
    try {
      const data = {
        event: "dw_exit_popup_conversion",
        action,
        timestamp: Date.now(),
      };

      sessionStorage.setItem("dw_exit_conversion", JSON.stringify(data));
    } catch (e) {}
  }

  /* ============================
     EXIT INTENT TRIGGER
     ============================ */

  const hasShownThisSession = sessionStorage.getItem("dw_exit_popup_shown");

  function onExitIntent(e) {
    const nearTop = e.clientY <= 10;
    const macTopLeft = e.clientY <= 30 && e.clientX <= 40;

    if (!nearTop && !macTopLeft) return;
    if (popupShown) return;
    if (hasShownThisSession) return;

    popupShown = true;
    sessionStorage.setItem("dw_exit_popup_shown", "true");

    markPopupView();
    renderPopup();
    showPopup();
  }

  // Add listener after delay
  setTimeout(() => {
    document.addEventListener("mouseleave", onExitIntent);
  }, 1200);

  /* ============================
     CART + FIRST VIEWED PRODUCT
     ============================ */

  async function getCart() {
    try {
      const res = await fetch("/cart.js", { cache: "no-store" });
      return await res.json();
    } catch (err) {
      return { items: [] };
    }
  }

  function getFirstViewedProduct() {
    const handle = sessionStorage.getItem("dw_first_viewed_product");
    const title = sessionStorage.getItem("dw_first_viewed_title");
    const image = sessionStorage.getItem("dw_first_viewed_image");

    if (!handle) return null;
    return { handle, title, image };
  }

  /* ============================
     POPUP CONTENT TEMPLATES
     ============================ */

  function loggedOutDiscountHTML() {
    return `
      <div class="dw-center">
        <div class="dw-badge">First Time Visitor?</div>
        <h3 class="dw-title">Get 10% Off Your First Order</h3>

        <div class="dw-discount-box">
          <p class="dw-small">Use code:</p>
          <div class="dw-code">WELCOME10</div>
        </div>

        <button class="dw-btn dw-black"
          data-dw-action="claim"
          onclick="
            sessionStorage.setItem('dw_clicked_discount', 'true');
            location.href='/checkout?discount=WELCOME10&utm_source=HumanityAI&utm_medium=popup&utm_campaign=exit_intent';
          ">
          → Claim Discount
        </button>

        <button class="dw-btn dw-outline dw-close-alt"
          data-dw-action="dismiss">
          No Thanks
        </button>

        <p class="dw-small" style="margin-top:1rem;">
          * Discount applies to full-price items only. First-time customers only.
        </p>
      </div>
    `;
  }

  function loggedInCartHTML(item) {
    const img = item.image || item.featured_image?.url;
    return `
      <div class="dw-center">
        <div class="dw-badge">Wait!</div>
        <h3 class="dw-title">Don't Forget This Item!</h3>

        <img src="${img}" class="dw-img" />
        <p class="dw-item-title">${item.title}</p>

        <button class="dw-btn dw-black"
          data-dw-action="view_cart"
          onclick="location.href='/cart?utm_source=HumanityAI&utm_medium=popup&utm_campaign=exit_intent'">
          → Go To Cart
        </button>

        <button class="dw-btn dw-outline dw-close-alt"
          data-dw-action="dismiss">
          Continue Shopping
        </button>
      </div>
    `;
  }

  function loggedInFirstViewHTML(p) {
    return `
      <div class="dw-center">
        <div class="dw-badge">Still Thinking?</div>
        <h3 class="dw-title">That Product Is Waiting For You</h3>

        <img src="${p.image}" class="dw-img" />
        <p class="dw-item-title">${p.title}</p>

        <button class="dw-btn dw-black"
          data-dw-action="view_product"
          onclick="location.href='/products/${p.handle}?utm_source=HumanityAI&utm_medium=popup&utm_campaign=exit_intent'">
          → View Product
        </button>

        <button class="dw-btn dw-outline dw-close-alt"
          data-dw-action="dismiss">
          Maybe Later
        </button>
      </div>
    `;
  }

  function loggedInFallbackHTML() {
    return `
      <div class="dw-center">
        <div class="dw-badge">Before You Go...</div>
        <h3 class="dw-title">Check Out Our Latest Arrivals</h3>

        <button class="dw-btn dw-black"
          data-dw-action="new_arrivals"
          onclick="location.href='/collections/new-arrivals?utm_source=HumanityAI&utm_medium=popup&utm_campaign=exit_intent'">
          → Shop New Arrivals
        </button>

        <button class="dw-btn dw-outline dw-close-alt"
          data-dw-action="dismiss">
          No Thanks
        </button>
      </div>
    `;
  }

  /* ============================
     RENDER POPUP
     ============================ */

  async function renderPopup() {
    const cart = await getCart();

    // LOGGED IN USERS: Never show discount offer
    if (isLoggedIn) {
      console.log("🔒 Logged-in user - showing personalized content (no discount)");
      
      if (cart.items.length > 0) {
        content.innerHTML = loggedInCartHTML(cart.items[0]);
        return;
      }

      const first = getFirstViewedProduct();
      if (first) {
        content.innerHTML = loggedInFirstViewHTML(first);
        return;
      }

      content.innerHTML = loggedInFallbackHTML();
      return;
    }

    // LOGGED OUT USERS: Show discount offer
    console.log("👤 Guest user - showing discount offer");
    content.innerHTML = loggedOutDiscountHTML();
  }

  /* ============================
     SHOW POPUP
     ============================ */
  function showPopup() {
    popup.style.display = "block";
  }

  /* ============================
     CLICK HANDLERS (EVENT DELEGATION)
     ============================ */

  document.addEventListener("click", function (e) {
    if (!popupShown) return;

    // Close (X or No Thanks buttons)
    if (e.target.closest(".dw-close") || e.target.closest(".dw-close-alt")) {
      markPopupConversion("dismiss");
      popup.style.display = "none";
      return;
    }

    // Action buttons
    const actionBtn = e.target.closest("[data-dw-action]");
    if (actionBtn) {
      markPopupConversion(actionBtn.dataset.dwAction);
    }
  });

})();
